import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-password-recovery',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, RouterModule],
  templateUrl: './recovery.component.html',
  styleUrls: ['./recovery.component.css']
})
export class RecoveryComponent {
  recoveryForm: FormGroup;
  isSubmitted: boolean = false;
  isLoading: boolean = false;
  emailSent: boolean = false;
  rateLimited: boolean = false;
  generalError: string = '';
  showGeneralError: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService
  ) {
    this.recoveryForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  onSubmit(): void {
    this.isSubmitted = true;
    this.showGeneralError = false;
    this.rateLimited = false;

    if (this.recoveryForm.valid) {
      this.isLoading = true;
      const email = this.recoveryForm.value.email;
      
      this.authService.requestPasswordReset(email)
        .then((success) => {
          this.isLoading = false;
          if (success) {
            this.emailSent = true;
            this.recoveryForm.reset();
            this.isSubmitted = false;
          }
        })
        .catch((error: Error) => {
          this.isLoading = false;
          console.error('Error requesting password reset:', error);
          
          if (error.message.includes('rate limit') || error.message.includes('429')) {
            this.rateLimited = true;
            this.showError('RECOVERY.RATE_LIMIT_ERROR');
          } else if (error.message.includes('not found') || error.message.includes('404')) {
            this.showError('RECOVERY.EMAIL_NOT_FOUND');
          } else {
            this.showError('RECOVERY.GENERAL_ERROR');
          }
        });
    }
  }

  private showError(messageKey: string): void {
    this.generalError = messageKey;
    this.showGeneralError = true;
  }
  getErrorMessage(field: string): string {
    const control = this.recoveryForm.get(field);
    if (control?.hasError('required')) {
      return 'RECOVERY.EMAIL_REQUIRED';
    }
    if (control?.hasError('email')) {
      return 'RECOVERY.EMAIL_INVALID';
    }
    return '';
  }

  hasError(field: string): boolean {
    const control = this.recoveryForm.get(field);
    return !!(this.isSubmitted && control?.invalid);
  }

  hasGeneralError(): boolean {
    return this.showGeneralError;
  }

  getGeneralError(): string {
    return this.generalError;
  }
}
